import script from "./HelperHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelperHeader.vue?vue&type=script&setup=true&lang=ts"

import "./HelperHeader.vue?vue&type=style&index=0&id=2ba9cb4a&lang=less&scoped=true"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba9cb4a"]])

export default __exports__